import * as React from 'react';

import { observer } from 'mobx-react';

import * as classnames from 'classnames';

import { IPasswordStrength } from '~domain/entities/Config';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';
import { PasswordStrengthViewController } from '~views/components/PasswordStrengthViewController';

const componentName = 'passwordStrength';
const rootClassName = classes(`iam-${componentName}`);
const levelClassName = classes(`iam-${componentName}-level`);
const meterWrapperClassName = classes(`iam-${componentName}-meter-wrapper`);
const meterBlockClassName = classes(`iam-${componentName}-meter-block`);

@observer
export class PasswordStrength extends React.Component<IPasswordStrength> {
    private passwordStrengthViewController: PasswordStrengthViewController;

    constructor(props: IPasswordStrength) {
        super(props);
        this.passwordStrengthViewController = diContainer.get(
            serviceNames.passwordStrengthViewController
        );
        this.passwordStrengthViewController.loaded(this.props);
    }

    public render() {
        const {
            data: {
                levelData: { level, levelName, levelLabel },
                totalLevel,
                isShown
            }
        } = this.passwordStrengthViewController;
        const { inputLabel } = this.props;

        return (
            isShown && (
                <div className={classnames(rootClassName, levelName)}>
                    <div className={levelClassName}>
                        {inputLabel || ''}
                        {levelLabel}
                    </div>
                    <div className={meterWrapperClassName}>
                        {Array.from(Array(totalLevel)).map((item, index) => {
                            return (
                                <li
                                    key={item}
                                    className={classnames(
                                        meterBlockClassName,
                                        index < level ? 'active' : 'inactive'
                                    )}
                                ></li>
                            );
                        })}
                    </div>
                </div>
            )
        );
    }
}
